import { render, staticRenderFns } from "./CourseBookSection.vue?vue&type=template&id=6a157da0&scoped=true&"
import script from "./CourseBookSection.vue?vue&type=script&lang=js&"
export * from "./CourseBookSection.vue?vue&type=script&lang=js&"
import style0 from "./CourseBookSection.vue?vue&type=style&index=0&id=6a157da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a157da0",
  null
  
)

export default component.exports